(ns quuppa.qsm.boot-command.view
  (:require [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.ui.spinner :refer [spinner]]
            [quuppa.qsm.boot-command.events :as e]
            [quuppa.qsm.release.view :as release]))

(defn view [{qpe-name :name} {:keys [qpe-identity] :as opts}]
  [:div.card.bg-gray-30.p-2.pl-3.flex-shrink-1
   [:div.d-flex.align-items-center.mb-1
    [:h5.py-2.my-0.flex-grow-1 "QPE-boot"]]

   [:dl.m-0
    [:f> release/qpe-boot-update-information opts]]

   (let [{:keys [loading error result]} @(q/subscribe e/boot-commands-query {:qpe-identity qpe-identity})
         by-command (into {}
                          (map (juxt :command identity))
                          result)
         {:keys [id] :as kill-qpe} (get by-command "kill-qpe")]
     (cond
       loading
       [spinner]

       error
       [:div.text-danger (str "Failed to load commands: " error)]

       result
       [:table.table.table-sm.align-middle.my-0
        [:thead
         [:tr
          [:td "Command"]
          [:td "State"]]]
        [:tbody
         [:tr
          [:td.w-25.border-0
           "Restart QPE"]
          [:td.w-75.border-0
           (if kill-qpe
             [:div
              "Pending"
              [:button.btn.btn-primary.ml-2
               {:on-click (fn [_]
                            (rf/dispatch [:qpe-boot/revoke-command {:qpe-identity qpe-identity
                                                                    :id id
                                                                    :qpe-name qpe-name
                                                                    :command-name "Restart QPE"}]))}
               "Revoke"]]
             [:button.btn.btn-primary
              {:on-click (fn [_]
                           (when (js/confirm "Are you sure?")
                             (rf/dispatch [:qpe-boot/register-command {:qpe-identity qpe-identity
                                                                       :command "kill-qpe"
                                                                       :qpe-name qpe-name
                                                                       :command-name "Restart QPE"}])))}
              "Issue command"])]]]]))])
